import { formatDateString } from "./datesFormatter";

export const createGasState = state => {
  let Resultados = state.Resultados.filter(r => r.Unidad != "");
  return {
    TotalKilosServidos: Resultados.reduce(
      (acum, value) => acum + value.KilosServidos,
      0
    ),
    TotalLitrosServidos: Resultados.reduce(
      (acum, value) => acum + value.LitrosServidos,
      0
    ),
    TotalCantidadClientesVisitados: Resultados.reduce(
      (acum, value) => acum + value.CantidadClientesVisitados,
      0
    ),
    TotalClientesVisitados: Resultados.reduce(
      (acum, value) => acum.concat(value.ClientesVisitados),
      []
    ).reduce((acum, value) => {
      let index = acum.findIndex(a => value.Cliente == a.Cliente);

      if (index == -1) {
        acum.push(value);
        return acum;
      } else {
        acum[index].CantidadServicios += value.CantidadServicios;
        acum[index].LitrosServidos += value.LitrosServidos;
        acum[index].KilosServidos += value.KilosServidos;
        acum[index].PrecioTotal += value.PrecioTotal;
        return acum;
      }
    }, []),
    TotalServicios: Resultados.reduce(
      (acum, value) =>
        acum.concat(
          value.Servicios.map(s => ({
            Fecha: formatDateString(s.Fecha),
            ...s
          }))
        ),
      []
    ),
    TotalVentasDescuento: Resultados.reduce(
      (acum, value) => acum + value.CantidadVentasDescuento,
      0
    ),
    TotalVentas: Resultados.reduce((acum, value) => acum + value.TotalVenta, 0),
    UnidadConMasServicios: Resultados.sort((a, b) => {
      if (a.Servicios.length > b.Servicios.length) return 1;
      else if (a.Servicios.length < b.Servicios.length) return -1;
      else return 0;
    })[Resultados.length - 1],

    UnidadConMenosServicios: Resultados.sort((a, b) => {
      if (a.Servicios.length > b.Servicios.length) return 1;
      else if (a.Servicios.length < b.Servicios.length) return -1;
      else return 0;
    })[0],

    MejorCliente: Resultados.reduce(
      (acum, value) => acum.concat(value.ClientesVisitados),
      []
    ).reduce(
      (acum, value) => {
        if (value.PrecioTotal > acum.PrecioTotal)
          return {
            PrecioTotal: value.PrecioTotal,
            Cliente: value.Cliente
          };
        else
          return {
            PrecioTotal: acum.PrecioTotal,
            Cliente: acum.Cliente
          };
      },
      { Cliente: "", PrecioTotal: 0 }
    ),
    Resultados
  };
};



// WEBPACK FOOTER //
// ./src/utilities/gas.js